/**
 * This helper module holds the Vue application instance.
 * It's used to avoid circular dependencies by providing a central place
 * to access the app instance after it has been initialized in main.js.
 */
let app;

/**
 * Sets the Vue app instance. This should only be called once from main.js.
 * @param {object} vueApp - The created Vue app instance.
 */
export function setApp(vueApp) {
	app = vueApp;
}

/**
 * Gets the stored Vue app instance.
 * @returns {object} The Vue app instance.
 */
export function getApp() {
	return app;
}